/* eslint-disable */
import Vue from "vue";
import VueRouter from "vue-router";
import HomeVue from "../views/Home.vue";
import LoginVue from "../views/Login.vue";
import ConfirmationVue from "../views/Confirmation.vue";
import ConfirmationVuePortal from "../views/ConfirmationPatientPortal.vue";

Vue.use(VueRouter);

export function createRouter() {
    const router = new VueRouter({
        mode: "history",
        routes: [
            { path: "/", component: HomeVue },
            { path: "/login", name: "Login", component: LoginVue },
            { path: "/confirmation", name: "Confirmation", component: ConfirmationVue, props: true },
            { path: "/confirmationPortal", name: "ConfirmationPortal", component: ConfirmationVuePortal, props: true },

            // otherwise redirect to home
            { path: "*", redirect: "/" },
        ],
    });

    router.beforeEach((to, from, next) => {
        // redirect to login page if not logged in and trying to access a restricted page
        const publicPages = ["/login"];
        const authRequired = !publicPages.includes(to.path);
        const loggedIn = localStorage.getItem("user");

        if (authRequired && !loggedIn) {
            return next("/login");
        }
        next();
    });

    return router;
}